var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcCheckBold = function SvgIcCheckBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.134 5.616a1.25 1.25 0 0 1 0 1.768l-10.998 11a1.25 1.25 0 0 1-1.768 0l-5.502-5.5a1.25 1.25 0 0 1 1.768-1.768l4.617 4.616L19.366 5.616a1.25 1.25 0 0 1 1.768 0",
    clipRule: "evenodd"
  })));
};
export default SvgIcCheckBold;